import { all, fork } from "redux-saga/effects";
import { createRequest } from "../utils";
import { oauthAppsActions } from ".";
import api from "../../utils/api";

// Load OAuth apps from CRM API `/oauth-apps` endpoint
const getOAuthAppsRequest = createRequest(oauthAppsActions.GET_OAUTH_APPS, api.get, () => ({
  url: `/oauth-apps`,
}));

// Create OAuth app via CRM API `/oauth-apps` endpoint
const createOAuthAppRequest = createRequest(oauthAppsActions.CREATE_OAUTH_APP, api.post, (action) => {
  const { name, redirectURI, grantTypes, scope, userID, trusted } = action.payload;

  const body = {
    name,
    redirect_uri: redirectURI,
    grant_types: grantTypes,
    scope,
    user_id: userID,
    trusted,
  };

  return {
    url: `/oauth-apps`,
    body: JSON.stringify(body),
  };
});

// Delete OAuth app via CRM API DELETE /oauth-apps/:client_id
const deleteOAuthAppRequest = createRequest(oauthAppsActions.DELETE_OAUTH_APP, api.delete, (action) => ({
  url: `/oauth-apps/${encodeURIComponent(action.payload.clientID)}`,
}));

export default function* rootSaga() {
  yield all([fork(getOAuthAppsRequest), fork(createOAuthAppRequest), fork(deleteOAuthAppRequest)]);
}
